// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumb":"Breadcrumb_Breadcrumb__1H8Jj"};